import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'My Profile title',
    defaultMessage: 'My Profile',
    id: '3DUytl',
  },
  personalInformationSubheader: {
    description: 'Personal information subtitle',
    defaultMessage: 'Personal Information',
    id: 'J3rVsN',
  },
  fullName: {
    description: 'Full name field',
    defaultMessage: 'Full Name',
    id: 'dEPHL9',
  },
  email: {
    description: 'Email field',
    defaultMessage: 'Email',
    id: 'Nh/LW6',
  },
  weeklyDigest: {
    description: 'Recieve weekly digest checkbox copy',
    defaultMessage: 'Receive a weekly digest email',
    id: '96OV/c',
  },
  changePasswordSubheader: {
    description: 'Change password subheader',
    defaultMessage: 'Change Your Password',
    id: '69/mXz',
  },
  currentPassword: {
    description: 'Current password field',
    defaultMessage: 'Current password',
    id: 'o6IVzF',
  },
  newPassword: {
    description: 'New password field',
    defaultMessage: 'New password',
    id: '80stZ/',
  },
  newPasswordInstructions: {
    description: 'Instructions for password field',
    defaultMessage: 'Minimum of 7 characters. No spaces.',
    id: 'eSr1za',
  },
  verifyPassword: {
    description: 'Verify password field',
    defaultMessage: 'Verify password',
    id: '2gKlXb',
  },
  changePasswordButton: {
    description: 'Change password button text',
    defaultMessage: 'Change Password',
    id: 'lynO1X',
  },
  updateProfileButton: {
    description: 'Update Profile button',
    defaultMessage: 'Update Profile',
    id: 'lTcZ+X',
  },
  changesSaved: {
    description: 'settings.my-profile.changesSaved',
    defaultMessage: 'Changes saved successfully!',
    id: 'amdmI2',
  },
  changesFailed: {
    description: 'settings.my-profile.changesFailed',
    defaultMessage: 'Changes failed to save.',
    id: 'ITZzoO',
  },
  couldNotValidate: {
    description: 'settings.my-profile.couldNotValidate',
    defaultMessage: 'Could not validate user, changes failed to save.',
    id: '5E9JbP',
  },
  unlinkSsoAccountConfirmation: {
    description: 'settings.my-profile.unlinkSsoAccountConfirmation',
    defaultMessage: 'Are you sure you want to unlink this account?',
    id: 'mweFAz',
  },
  pleaseContactSupport: {
    description: 'email warning tooltip text',
    defaultMessage: 'Please contact support to change this email address.',
    id: 'gTHlee',
  },
  connectAccountSuccessTitle: {
    description: 'External Account: Successfully connected account title.',
    defaultMessage: 'Your {externalAccountName} Account is Connected!',
    id: '2WH5Sg',
  },
  connectAccountSuccessMsg: {
    description: 'External Account: Successfully connected account message.',
    defaultMessage:
      'You can now use your {externalAccountName} account to sign in to ShipStation. To remove this or any other third-party connections from this ShipStation account, use the "Third Party Login" controls below.',
    id: 'oJlz+d',
  },
});

export const errorMessages = defineMessages({
  notLongEnough: {
    description: 'Password not long enough',
    defaultMessage: 'The provided password must be at least 7 characters long.',
    id: 'vu2RmO',
  },
  noSpaces: {
    description: 'passwords must not have spaces',
    defaultMessage: 'The provided password cannot contain empty spaces.',
    id: '8mW/Kz',
  },
  invalidEmailSyntax: {
    description: 'Email invalid syntax',
    defaultMessage: 'The email provided must be a valid email syntax.',
    id: 'FgqrRm',
  },
  verifyMatch: {
    description: 'Password verify failed',
    defaultMessage: 'Your verify password must match your New Password.',
    id: 'b7vWDO',
  },
  passwordsMustNotMatch: {
    description: 'New password should not match old',
    defaultMessage: 'Your new password should not be the same as your old one.',
    id: '5UJT4O',
  },
  cannotBeEmpty: {
    description: 'field cannot be empty',
    defaultMessage: 'This field cannot be empty',
    id: 'nIfS0w',
  },
});

export default messages;
